import { FlowConfigTemplateString } from '../type/flow.type';

export function matchTemplateStr(
    title: FlowConfigTemplateString,
    pageUrl: string,
) {
    var defaultValue = '';

    if (typeof title === 'string') {
        defaultValue = title;
    } else if (title && title.default) {
        defaultValue = title.default;
    }

    if (
        !title ||
        typeof title === 'string' ||
        (typeof title !== 'string' && !title.template)
    ) {
        return defaultValue;
    }

    var fullUrl = new URL(pageUrl);
    var urlParams = new URLSearchParams(fullUrl.search);
    var patternStr = title.template;
    var paramMap: Record<string, string | null> = {};

    var matches = patternStr.match(/{{\w+}}/g);

    if (matches && matches.length) {
        matches.forEach((match) => {
            var paramName = match.replace('{{', '').replace('}}', '');

            var paramValue = urlParams.get(paramName) || null;

            if (!paramName) {
                return;
            }

            paramMap[paramName] = paramValue;

            patternStr = patternStr.replace(match, paramValue || '');
        });
    }

    // NOTE: If some of required query parameters are missing, show the default value instead
    if (Object.values(paramMap).includes(null)) {
        return defaultValue;
    }

    return patternStr;
}
